export default {"src":"/_next/static/media/enterpriseGradeReliability.b889eb22.svg","height":31,"width":30};